import * as React from 'react';

import FeedbackPointsDisplay from 'pages/open-course/peerReview/components/FeedbackPointsDisplay';
import OptionFeedbackRow from 'pages/open-course/peerReview/components/OptionFeedbackRow';
import OptionFeedbackTable from 'pages/open-course/peerReview/components/OptionFeedbackTable';
import type { ReviewerDetails } from 'pages/open-course/peerReview/components/types';
import type Review from 'pages/open-course/peerReview/reviewTypes/structured/models/review';
import type reviewsSummaryShape from 'pages/open-course/peerReview/reviewTypes/structured/models/reviewsSummaryShape';
import type ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/options/models/schema';

import Content from 'bundles/phoenix/components/Content';

type Props = {
  reviewSchemaPart: typeof ReviewSchemaPart;
  reviewsSummary: reviewsSummaryShape;
  reviews: (typeof Review)[];
  isAIGraded: boolean;
  isAssignmentLevelPart: boolean;
};

const OptionsDisplayPart = (props: Props) => {
  const { reviewSchemaPart, reviewsSummary, reviews, isAIGraded, isAssignmentLevelPart } = props;

  const partId = reviewSchemaPart.get('id');
  const options = reviewSchemaPart.getSortedOptions();

  const getReviewChoice = (review: $TSFixMe) => review.get('parts').get(partId).get('choice');

  const getReviewsForOptionId = (optionId: $TSFixMe) => {
    return reviews.filter((review: $TSFixMe) => getReviewChoice(review) === optionId);
  };

  const reviewChoices = reviews.map(getReviewChoice);
  const reviewsSummaryPart = reviewsSummary && reviewsSummary.definition.parts[partId];
  const reviewsSummaryScore = reviewsSummaryPart && reviewsSummaryPart.score;
  const checkedOption = reviewSchemaPart.getOptionBestRepresentingReviews(reviewChoices, reviewsSummaryScore);
  const checkedOptionId = checkedOption && checkedOption.optionId;

  const optionRows = options.map((option: $TSFixMe) => {
    const optionId = option.optionId;
    const reviewersForOption: ReviewerDetails[] = getReviewsForOptionId(optionId).map((review: $TSFixMe) => {
      return {
        fullName: review.get('creator.fullName'),
        isDefaultPhoto: review.get('creator.isDefaultPhoto'),
        isAnonymous: review.get('creator.isAnonymous'),
        photoUrl: review.get('creator.photoUrl'),
      };
    });
    const checked = optionId === checkedOptionId;
    return (
      <OptionFeedbackRow
        reviewers={reviewersForOption}
        checked={checked}
        groupId={partId}
        optionId={optionId}
        key={optionId}
        isAIGraded={isAIGraded}
        isAssignmentLevelPart={isAssignmentLevelPart}
      >
        {reviewSchemaPart.get('isScored') && (
          <div>
            <FeedbackPointsDisplay
              actualPoints={checked ? reviewsSummaryScore : undefined}
              points={option.points}
              checked={checked}
            />
          </div>
        )}
        <Content content={option.display} />
      </OptionFeedbackRow>
    );
  });

  return (
    <div className="rc-OptionsDisplayPart">
      <Content content={reviewSchemaPart.get('prompt')} />
      <OptionFeedbackTable>{optionRows}</OptionFeedbackTable>
    </div>
  );
};

export default OptionsDisplayPart;
